import {useState, useEffect} from 'react';
import DropdownMenu from '../StockItems/DropdownMenu';
import ScaledTemplate from './ScaledTemplate';
import * as IntroFns from '../utilities/IntroFns';
import * as ServerComms from '../utilities/ServerComms';
import * as SharedAcross from '../utilities/SharedAcross';
import * as CoreFns from '../utilities/CoreFns';
import * as EditorFunctions from '../utilities/EditorFunctions';
import * as SearchForAnEntityType from '../utilities/SearchForAnEntityType';
import * as DesignerFunctions from '../utilities/DesignerFunctions';
import ShowAPage from '../PopUps/ShowAPage';
import DoSpecificItem from '../PopUps/DoSpecificItem';
import NormalBtn from '../StockItems/NormalBtn';

function App(props) {

  var insetHeight = props.insetHeight;
  var detailsWidth = props.detailsWidth;
  var insetWidth = props.insetWidth;
  var overallWidth = props.overallWidth;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var userID = props.userID;
  var offsetTop = props.offsetTop;
  var offsetLeft = props.offsetLeft;
  var chains = props.chains;
  var currentList = props.currentList;
  var changeTab = props.changeTab;
  var itemEdited = props.itemEdited;
  var itemCategories = props.itemCategories;

  var itemTypes = [{i:'dapp', n:'Dapp'}, {i:'fe', n:'Front End'}, {i:'pu', n:'Pop Ups'}, {i:'BUTTON', n:'Button'}, {i:'INPUT', n:'Input'}, {i:'GALLERY', n:'Gallery'}, {i:'HFLEX', n:'Row'}, {i:'NAVBAR', n:'Navigation Bar'}, {i:'CONTAINER', n:'Container'}, {i:'ALERT', n:'Alert'}, {i:'FOOTER', n:'Footer'}, {i:'PANEL', n:'Panel'}, {i:'SUMMARY', n:'Summary'}, {i:'DIV', n:'Text Box'}];

  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(-1);
  const [filterBit, setFilterBit] = useState('noFilter');
  const [itemType, setItemType] = useState('dapp');

  var pathDown;
  var thisItem;
  var itemTypeX = '';
  if (itemEdited){
    pathDown = itemEdited.path;
    try{
      thisItem = CoreFns.goDownPath(currentList, pathDown);
      itemTypeX = DesignerFunctions.getItemType(pathDown);
      if (itemTypeX === 'item'){
        itemTypeX = thisItem.t;
      }
    }catch(err){
    }
  }else{
    itemTypeX = 'dapp';
  }

  var organicChanges = function(e){
    
  }

  function setThisItemType(x){
    setTemplates([]);
    setItemType(x);
    refreshTemplates(x);
  }

  useEffect(() => {
    refreshTemplates(itemType);
   }, []); // eslint-disable-line react-hooks/exhaustive-deps

  
  function clickClickTemplate(aTemplate){
    return function(e){
      setSelectedTemplate(aTemplate);
    }
  }

  function refreshTemplates(itemTypeIn){
      function postGetTemplates(response){
        if (response.t === 'list'){
          var t = response.v.map((aT, index)=>{
            var categories = aT.v[2].v.split('_').map((aCat, index)=>{
              return +aCat;
            })          
            var set = {i:aT.v[0].v, v:JSON.parse(aT.v[1].v), t:categories, priority:aT.v[3].v};
            if (itemTypeIn === 'dapp'){
            }else{
              set.as = JSON.parse(aT.v[4].v);
              set.desc = aT.v[5].v;
            }
            return set
          })
        }
        setTemplates(t);
      }
      ServerComms.fetchSomething({u:'getTemplatesForAdmin', itemType:itemTypeIn, userID, signKey, sessionID}, postGetTemplates);
  }

  function clickRefreshTemplates(e){
    refreshTemplates(itemType);
  }

  function doSummary(){
      var thisItem1 = JSON.parse(JSON.stringify(thisItem));
      var itemPath = pathDown;

      var currentListA = JSON.parse(JSON.stringify(currentList));

      var warningsHere = EditorFunctions.doASetOfUploadOrDownloadTemplateModifiers(thisItem1, itemType, itemPath, 'elementUploadChecks', currentListA, chains, changeTab);

      var richText = [];
      if (itemType === 'PANEL'){
        richText = SearchForAnEntityType.searchPanel(thisItem1, itemPath, 'RICHTEXT');
      }else if (itemType === 'FOOTER'){
        richText = SearchForAnEntityType.searchFooter(thisItem1, itemPath, 'RICHTEXT');
      }else if (itemType === 'navBar'){
        if (thisItem1.on){
          if (thisItem1.on === 1){
          }else{
            thisItem1 = currentListA.cn[thisItem1.on].nv;
            thisItem1.on = 1;
          }
        }
        richText = SearchForAnEntityType.searchNavBar(thisItem1, itemPath, 'RICHTEXT', currentListA);
      }else if (itemType === 'fe' || itemType === 'pu'){
        if (thisItem1.nv && thisItem1.nv.on){
          if (thisItem1.nv.on === 1){
          }else{
            thisItem1.nv = currentListA.cn[thisItem1.nv.on].nv;
            thisItem1.nv.on = 1;
          }
        }
        richText = SearchForAnEntityType.searchPage(thisItem1, itemPath, 'RICHTEXT', true, currentListA);
      }else{
        richText = SearchForAnEntityType.searchItem(thisItem1, itemPath, 'RICHTEXT');
      }

      var richTextObject = {};
      var aS = currentListA.as;
      richText.forEach((aRText, index)=>{
        richTextObject[aRText.item.i] = aS[aRText.item.i];
      })
      if (warningsHere.length === 0){     
        return {c:JSON.stringify(thisItem1), a:JSON.stringify(richTextObject)};
      }else{
        window.alert('Uploading not possible : ' + warningsHere[0].n);
        return;
      }          

  }


  function submitItemTemplate(e){

    var p = doSummary();
    if (p){
      var pText = window.prompt('Description');
      if (pText !== undefined && pText !== null){
        pText = pText.trim();
        ServerComms.fetchSomething({u:'submitItemAsTemplate', c:p.c, a:p.a, description:pText, itemType, sessionID, signKey, userID}, clickRefreshTemplates);
      }
    }

  }


  function deleteTemplate(e){

    ServerComms.fetchSomething({u:'deleteTemplate', itemType, templateID:selectedTemplate, sessionID, signKey, userID}, clickRefreshTemplates);
  }



  var actualOptions = IntroFns.actualOptions(itemCategories, itemType);
  var filteredTemplates = IntroFns.filteredTemplates(templates, filterBit);


  var uploadLine;

  if (itemType === itemTypeX){
    if (itemType === 'dapp'){
      function toExecute(){
        var c = JSON.parse(JSON.stringify(currentList));
        ServerComms.fetchSomething({u:'submitTemplate', c:JSON.stringify(c), sessionID, signKey, userID}, clickRefreshTemplates);    
      }  

      uploadLine = <NormalBtn onClick={toExecute} title='Update dApp as template' backScreen={true} icon='mdi:rocket-launch-outline'/>

    }else{
      var title = DesignerFunctions.fullTitle(itemEdited, currentList, pathDown, thisItem);
      uploadLine = <NormalBtn onClick={submitItemTemplate} title={'Update '+title+' as template'} backScreen={true} icon='mdi:rocket-launch-outline'/>      
    }
  }else if (itemType === 'dapp'){
    uploadLine = <div>Click on a blank space to upload the entire dApp</div>
  }else{
    uploadLine = <div>Click on a {CoreFns.getElementInfo(itemType).t} to upload it</div>
  }
//
  function handleChange(categoryID, templateID, currentChecked){
    return function(e){
      ServerComms.fetchSomething({u:'modCat', itemType, templateID, sessionID, signKey, userID, categoryID, status:(currentChecked ? 0 : 1)}, clickRefreshTemplates);

    }
  }

  function changePriority(aTemplate){
    return function(e){
      var newPriority = window.prompt('Set Priority (higher numbers are shown earlier)', aTemplate.priority);
      if (SharedAcross.isIntegerText(newPriority)){

        ServerComms.fetchSomething({u:'modPageTemplatePriority', itemType, templateID:aTemplate.i, sessionID, signKey, userID, priority:+newPriority}, clickRefreshTemplates);

      }else if (newPriority){
        window.alert('Need integer priority');
      }
    }
  }

  function changeDescription(aTemplate){
    return function(e){
      var newPriority = window.prompt('Set Description', aTemplate.desc);
      if (newPriority){
        ServerComms.fetchSomething({u:'changeItemTemplateDescription', itemNos:aTemplate.i, sessionID, signKey, userID, desc:newPriority}, clickRefreshTemplates);
      }
    }
  }

  function updateTemplate(e){
    var p = window.confirm('Are you sure you want to replace this template with the current dApp?');
    if (p){
      if (itemType === 'dapp'){
        ServerComms.fetchSomething({u:'updateTemplate', itemType, templateID:selectedTemplate, c:JSON.stringify(currentList), sessionID, signKey, userID}, clickRefreshTemplates);          
      }else{
        var p1 = doSummary();
        if (p1){
          ServerComms.fetchSomething({u:'updateTemplate', itemType, templateID:selectedTemplate, c:p1.c, a:p1.a, sessionID, signKey, userID}, clickRefreshTemplates);          
        }
      }
    }
  }  

  var pagePieces = filteredTemplates.map((aTemplate, index)=>{

      var inside;

      var clickH = clickClickTemplate(aTemplate.i);

      if (itemType === 'dapp'){
        var w = (detailsWidth - 100);
        var h = (detailsWidth - 100)* (insetHeight - 42)/insetWidth;

        var cList = aTemplate.v;
        var whichFE = cList._g.ss;
        var fe = cList.fe;
        if (fe[whichFE]){
        }else{
          whichFE = Object.keys(fe)[0];
        }
        inside = <ScaledTemplate chains={chains} overallWidth={overallWidth} w={w} h={h} whichFEOrPU={{t:'fe',v:whichFE}} error={false} currentList={cList} onClick={clickH} offsetTop={offsetTop} offsetLeft={offsetLeft}/>
      }else if (itemType === 'fe' || itemType === 'pu'){
        inside = <ShowAPage isFEOrPU={itemType} insetWidth={insetWidth} overallWidth={overallWidth} insetHeight={insetHeight} expressedWidth={detailsWidth} currentList={currentList} chains={chains} aTemplate={aTemplate} onClick={clickH}/>
      }else{
        try{
          var pPiece = null;
          var classCover = '';
          var addPath = [];
          inside = <DoSpecificItem clickItem={clickH} itemT={itemType} addPath={addPath} width={detailsWidth} height={detailsWidth} insetWidth={insetWidth} insetHeight={insetHeight} currentList={currentList} organicChanges={organicChanges} chains={chains} anItemSet={aTemplate} index={index+''} pPiece={pPiece} classCover={classCover} />

        }catch(err){
          console.log(err);
          inside = <div>Element with Error</div>
        }

      }
//
      var admin = null;
      if (aTemplate.i === selectedTemplate){
        var checks = actualOptions.map((anOption, index1)=>{

          var checked = false;
          for (var i = 0; i < aTemplate.t.length; i++){
            if (aTemplate.t[i] === anOption.i){
              checked = true;
              break;
            }
          }
          return <label key={index1}>
          &nbsp;&nbsp;<input
            type='checkbox'
            checked={checked}
            onChange={handleChange(anOption.i, aTemplate.i, checked)}
          /> {anOption.n}
        </label>
        })
        var descPart;
        if (itemType !== 'dapp'){
          descPart = <div style={{cursor:'pointer', textDecoration:'underline'}} onClick={changeDescription(aTemplate)}>Description : {aTemplate.desc}</div>
        }

        var updateLine
        if (itemType === itemTypeX){
          updateLine = <button key='c' onClick={updateTemplate}>Update</button>
        }
        admin = <div>
                  <div key='a' style={{color:'white'}}>ID : {aTemplate.i}</div>
                  <button key='b' onClick={deleteTemplate}>Delete</button>
                  {updateLine}
                  <br/>
                  {checks}
                  <div style={{cursor:'pointer', textDecoration:'underline'}} onClick={changePriority(aTemplate)}>Priority : {aTemplate.priority}</div>
                  {descPart}
                </div>
      }else{
        admin = <button onClick={clickH}>Edit</button>
      }
  //  

        return <div style={{marginTop:'20px', marginLeft:'10px', padding:'5px', border:'1px solid #888888'}}>
                {inside}
                {admin}
              </div>

    })    

//

  var filterOptions = [{n:'No Filter', i:'noFilter', a:'fluent:border-none-20-regular'}].concat(actualOptions);

  function onMouseOver(e){
  }

   return <div><br/><center>
     <DropdownMenu clickItemInSelect={setThisItemType} options={itemTypes} currentAnswer={itemType}/>
     <br/>
      {uploadLine}
      <br/>
      <div style={{zIndex:1001, padding:5}} onMouseOver={onMouseOver} >
      <DropdownMenu clickItemInSelect={setFilterBit} options={filterOptions} currentAnswer={filterBit}/>
      </div>
      {pagePieces}<br/>
      </center>
      </div>

}

export default App;
